/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportMachineUtilizationDaily { 
    date?: string;
    production?: number;
    standby?: number;
    cip?: number;
    startup?: number;
    standstill?: number;
    slowing_down?: number;
}

